import React, { useState, useEffect, useContext } from "react"
import { Color, Pattern, Gradient, Shape } from "./ActionTypes"
import triangle from "../Imgs/triangle.png"

export default function Uploading(props) {
    const [text, setText] = useState("Uploading")
    const [loaded, setLoaded] = useState(false)
    const [desc, setDesc] = useState("Sending your file to Creative Cloud")
    const [file, setFile] = useState(triangle)
    const [action, setAction] = useState(props.location.pathname.split("/")[2])
    const components = {
        color: Color,
        pattern: Pattern,
        gradient: Gradient,
        shape: Shape
    }
    const titleDesc = { pattern: "geometric patterns", color: "Creating a color palette", shape: "Create a shape", gradient: "Create a gradient" }
    const ActionType = components[action] || components.pattern
    useEffect(() => {
        if (props.location.state) {
            const { file, action } = props.location.state
            setFile(file)
            setAction(action)
        }
        setLoaded(true)
    }, [])
    const loadedPanel = () => {
        return (
            <ActionType image={{ image: file, title: action, desc: titleDesc[action] }} className="firstPanel" />
        )
    }
    return (
        <>
            {loaded ? loadedPanel() : null}
        </>
    )
}